var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowRateLimit && _vm.showBannerOrCircle === 'banner')?_c('div',{attrs:{"data-testid":"rate-limit-counter-container"}},[_c('rate-limit-counter-banner',{attrs:{"credits-used":_vm.creditsUsed,"total-credits-available":_vm.totalCreditsAvailable},on:{"click":_vm.handleRateLimitClick}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }